module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/2-55603b681476c38c2012a555d006e015.png";